"use client";
import { useState, useEffect } from "react";
import { Modal, Button, Accordion } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { components } from "react-select";
import PropTypes from "prop-types";
import { getDoctorsAction } from "../../../../../store/actions/DoctorsAction";
import {
  getFollowUpReminderListAction
} from "../../../../../store/actions/FollowUpReminderAction"
import {
  getMedicineStartedAction,
  getPrescriptionExplainedAction,
  getPrescriptionSummaryAction,
  addReminderAction,
  addFollowupDelayAction,
  getScheduledListAction,
  sendScheduledAction
} from "../../../../../store/actions/ServiceFollowUpAction";
import Select from "react-select";
import QuestionnaireSection from "./QuestionnaireSection";
import FollowUpForm from "./FollowUpForm";
import pdfIcon from "../../../../../../src/assets/images/pdf.png";
import { showErrorAlert, handleSuccess } from "../../../../../services/ErrorHandlingService";
const PrescriptionFollowUp = ({
  selectedPrescriptionForFollowup,
  prescriptionKey,
  onClose,
  patientId,
  patientName,
  patientGender,
}) => {
  const dispatch = useDispatch();
  const [showDelayModal, setShowDelayModal] = useState(false);
  const [delayDays, setDelayDays] = useState("");
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  // Follow-up states
  const [showFollowUpForm, setShowFollowUpForm] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [reminderDate, setReminderDate] = useState("");
  const [reminderTime, setReminderTime] = useState("");
  const [prescriptionExplained, setPrescriptionExplained] = useState({});
  const [medicineStarted, setMedicineStarted] = useState({});
  const [selectedScheduleReason, setSelectedScheduleReason] = useState(null);
  const [followupList, setFollowupList] = useState([]);
  const [downloadingId, setDownloadingId] = useState(null)
  // API loading states
  const [prescriptionExplainedLoading, setPrescriptionExplainedLoading] =
    useState({});
  const [medicineStartedLoading, setMedicineStartedLoading] = useState({});
  const [reminderLoading, setReminderLoading] = useState(false);
  const [delayLoading, setDelayLoading] = useState(false);
  const [scheduledListLoading, setScheduledListLoading] = useState(false);

  // Date states for API calls
  const [prescriptionExplainedDates, setPrescriptionExplainedDates] = useState(
    {}
  );
  const [medicineStartedDates, setMedicineStartedDates] = useState({});

  // New states to track if data has been saved to API
  const [prescriptionExplainedSaved, setPrescriptionExplainedSaved] = useState(
    {}
  );
  const [medicineStartedSaved, setMedicineStartedSaved] = useState({});

  const serviceFollowupData = useSelector(
    (state) => state.serviceFollowup || {}
  );
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    if (isNaN(date)) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Get prescription summary data from Redux store
  const prescriptionSummaryData =
    serviceFollowupData.prescriptionSummaryData || {};
  const scheduledListData = serviceFollowupData.scheduledListData || {};

  const prescriptionId = selectedPrescriptionForFollowup?.prescription_id;
  console.log(
    "Selected Prescription for Follow-up:",
    selectedPrescriptionForFollowup
  );
  // const handleDownloadReceipt = async (prescriptionId, receiptDownloadLink) => {
  //   if (!receiptDownloadLink) {
  //     Swal.fire({
  //       title: "Download Not Available",
  //       text: "Receipt download link is not available for this prescription.",
  //       icon: "warning",
  //       confirmButtonText: "OK",
  //     })
  //     return
  //   }

  //   try {
  //     setDownloadingId(prescriptionId)

  //     // Use the receipt_download_link from the API response
  //     const response = await fetch(receiptDownloadLink, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/pdf",
  //       },
  //     })

  //     if (!response.ok) {
  //       throw new Error("Failed to download receipt")
  //     }

  //     // Create blob and download
  //     const blob = await response.blob()
  //     const url = window.URL.createObjectURL(blob)
  //     const link = document.createElement("a")
  //     link.href = url
  //     link.download = `prescription_receipt_${prescriptionId}.pdf`
  //     link.target = "_blank"
  //     document.body.appendChild(link)
  //     link.click()
  //     document.body.removeChild(link)
  //     window.URL.revokeObjectURL(url)

  //     Swal.fire({
  //       title: "Success!",
  //       text: "Receipt downloaded successfully!",
  //       icon: "success",
  //       confirmButtonText: "OK",
  //     })
  //   } catch (error) {
  //     console.error("Error downloading receipt:", error)
  //     Swal.fire({
  //       title: "Download Failed",
  //       text: "Failed to download receipt. Please try again.",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     })
  //   } finally {
  //     setDownloadingId(null)
  //   }
  // }
  // Replace with this dynamic data:
  const followupOptions = (scheduledListData?.data || []).map((schedule) => ({
    value: schedule.schedule_id,
    label: `${schedule.followup_count} (${schedule.followup_frequency_days} days)`,
    date: schedule.followup_date,
  }));

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div ref={innerRef} {...innerProps} style={{ padding: "10px" }}>
        <strong>{data.label}</strong>
        <div style={{ fontSize: "12px", color: "#666" }}>Date: formatDate{data.date}</div>
      </div>
    );
  };

  CustomOption.propTypes = {
    data: PropTypes.object.isRequired,
    innerRef: PropTypes.func,
    innerProps: PropTypes.object,
  };

  const CustomSingleValue = (props) => {
    const { data } = props;
    return (
      <components.SingleValue {...props}>
        {data.label} – {data.date}
      </components.SingleValue>
    );
  };

  CustomSingleValue.propTypes = {
    data: PropTypes.object.isRequired,
  };

  // dynamic data for follow-up
  const appointments = [
    {
      date: "07/04/2025",
      notes: [
        {
          title: "Questionnaire",
          content: [
            {
              question: "How are you feeling since your last visit?",
              answer: "Some symptoms have improved, but fatigue remains.",
            },
            {
              question:
                "Have you been taking the prescribed medications regularly?",
              answer: "Yes, I've been consistent.",
            },
          ].map((qa, index) => (
            <div key={index} className="mb-2">
              <strong>
                Q{index + 1}: {qa.question}
              </strong>
              <p>A: {qa.answer}</p>
            </div>
          )),
        },
        {
          title: "Notes",
          content: [
            "Patient missed last appointment, rescheduling requested.",
            "Patient confirmed visit for general check-up.",
          ].map((note, index) => <div key={index}>{note}</div>),
        },
      ],
    },
    {
      date: "08/04/2025",
      notes: [
        {
          title: "Prescription",
          content: (
            <div>
              <div
                style={{
                  fontSize: "0.9rem",
                  color: "#6c757d",
                  marginTop: "5px",
                  marginBottom: "1rem",
                }}
              >
                <strong>Prescribed Date:</strong>{" "}
                {selectedPrescriptionForFollowup?.date
                  ? formatDate(selectedPrescriptionForFollowup?.date)
                  : "N/A"}{" "}
                &nbsp;|&nbsp;
                <strong>Duration:</strong>{" "}
                {selectedPrescriptionForFollowup?.duration || "N/A"} days
                &nbsp;|&nbsp;
                <strong>Prescribed By:</strong>{" "}
                {selectedPrescriptionForFollowup?.prescribedBy ||
                  "Unknown Doctor"}
              </div>
              {(() => {
                // Separate medicines into custom and non-custom
                const regularMedicines =
                  selectedPrescriptionForFollowup?.medicines?.filter(
                    (medicine) => medicine.is_custom === "No"
                  ) || [];
                const customMedicines =
                  selectedPrescriptionForFollowup?.medicines?.filter(
                    (medicine) => medicine.is_custom === "Yes"
                  ) || [];

                return (
                  <>
                    {/* Regular Medicines Table */}
                    {regularMedicines.length > 0 && (
                      <div
                        style={{
                          border: "2px solid #ddd",
                          borderRadius: "5px",
                          marginBottom:
                            regularMedicines.length > 0 &&
                              customMedicines.length > 0
                              ? "24px"
                              : "0",
                          overflowX: "auto",
                        }}
                      >
                        {regularMedicines.length > 0 &&
                          customMedicines.length > 0 && (
                            <h5 className="p-2 border-bottom mb-0">
                              Regular Medicines
                            </h5>
                          )}
                        <table
                          className="table header-border mb-0"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd",
                            }}
                          >
                            <tr className="table-info">
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Medicine Name
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Dose
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Frequency
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Quantity
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                How to Take
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {regularMedicines.map((medicine, index) => (
                              <tr
                                key={medicine.prescription_medicine_id || index}
                              >
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.medicine_name}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.dose}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.frequency}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.qty}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.how_to_take}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Custom Medicines Table */}
                    {customMedicines.length > 0 && (
                      <div
                        style={{
                          border: "2px solid #ddd",
                          borderRadius: "5px",
                          marginBottom: "0",
                          overflowX: "auto",
                        }}
                      >
                        {regularMedicines.length > 0 &&
                          customMedicines.length > 0 && (
                            <h5 className="p-2 border-bottom mb-0">
                              Custom Medicines
                            </h5>
                          )}
                        <table
                          className="table header-border mb-0"
                          style={{ width: "100%", borderCollapse: "collapse" }}
                        >
                          <thead
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#f8f9fa",
                              zIndex: 10,
                              borderBottom: "2px solid #ddd",
                            }}
                          >
                            <tr className="table-info">
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Medicine Name
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Dose
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Frequency
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Quantity
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                Duration
                              </th>
                              <th
                                style={{
                                  padding: "10px",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                How to Take
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {customMedicines.map((medicine, index) => (
                              <tr
                                key={medicine.prescription_medicine_id || index}
                              >
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.medicine_name}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.dose}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.frequency}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.qty}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.custom_duration_in_days || "N/A"}
                                </td>
                                <td
                                  style={{
                                    padding: "10px",
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {medicine.how_to_take}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {/* Show message if no medicines */}
                    {regularMedicines.length === 0 &&
                      customMedicines.length === 0 && (
                        <div className="text-center text-muted py-4">
                          No medicines prescribed
                        </div>
                      )}
                  </>
                );
              })()}
            </div>
          ),
        },
      ],
    },
  ];

  const [filteredAppointments] = useState([...appointments]);

  useEffect(() => {
    dispatch(getDoctorsAction());
    // Fetch prescription summary data
    if (patientId) {
      dispatch(getPrescriptionSummaryAction(patientId));
    }
  }, [dispatch, patientId]);

  // Modified: Handle Prescription Explained Switch Change (No API call)
  const handlePrescriptionExplainedChange = (prescriptionKey, isChecked) => {
    setPrescriptionExplained((prev) => ({
      ...prev,
      [prescriptionKey]: isChecked,
    }));
    if (isChecked) {
      const currentDate = new Date().toISOString().split("T")[0];
      setPrescriptionExplainedDates((prev) => ({
        ...prev,
        [prescriptionKey]: currentDate,
      }));
    } else {
      // Reset saved status when switched to No
      setPrescriptionExplainedSaved((prev) => ({
        ...prev,
        [prescriptionKey]: false,
      }));
    }
  };
  const handleDownloadReceipt = async (prescriptionId, receiptDownloadLink) => {
    if (!receiptDownloadLink) {
      Swal.fire({
        title: "Download Not Available",
        text: "Receipt download link is not available for this prescription.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      setDownloadingId(prescriptionId);

      // Open the link directly (avoids CORS)
      const link = document.createElement("a");
      link.href = receiptDownloadLink;
      link.target = "_blank"; // open in new tab
      link.download = `prescription_receipt_${prescriptionId}.pdf`; // optional - triggers download name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Swal.fire({
      //   title: "Success!",
      //   text: "Receipt Downloaded successfully!",
      //   icon: "success",
      //   confirmButtonText: "OK",
      // });
    } catch (error) {
      console.error("Error opening receipt:", error);
      Swal.fire({
        title: "Failed to Open",
        text: "Unable to open the receipt. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setTimeout(() => setDownloadingId(null), 1000);
    }
  };

  // Modified: Handle Medicine Started Switch Change (No API call)
  const handleMedicineStartedChange = (prescriptionKey, isChecked) => {
    setMedicineStarted((prev) => ({
      ...prev,
      [prescriptionKey]: isChecked,
    }));
    if (isChecked) {
      const currentDate = new Date().toISOString().split("T")[0];
      setMedicineStartedDates((prev) => ({
        ...prev,
        [prescriptionKey]: currentDate,
      }));
    } else {
      // Reset saved status when switched to No
      setMedicineStartedSaved((prev) => ({
        ...prev,
        [prescriptionKey]: false,
      }));
    }
  };

  const handleSendScheduled = async () => {
    if (!prescriptionId || !patientId) {
      Swal.fire({
        title: "Error",
        text: "Missing patient or prescription ID",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
  
    try {
      const response = await dispatch(
        sendScheduledAction({
          patient_id: patientId,
          prescription_id: prescriptionId,
        })
      );
  
      if (response?.success) {
        handleSuccess("Schedule sent successfully");
      } else {
        throw new Error(response?.error || "Failed to send schedule");
      }
    } catch (error) {
      console.error("Send schedule error:", error);
      showErrorAlert("Failed to send schedule");
    }
  };

  // Modified: Save Prescription Explained Date with API call
  // const handleSavePrescriptionExplainedDate = async (prescriptionKey) => {
  //   const selectedDate = prescriptionExplainedDates[prescriptionKey];
  //   if (!selectedDate) {
  //     Swal.fire({
  //       title: "Missing Date",
  //       text: "Please select a date",
  //       icon: "warning",
  //       confirmButtonText: "OK",
  //     });
  //     return;
  //   }
  //   if (!prescriptionId) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Prescription ID is missing",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //     return;
  //   }

  //   setPrescriptionExplainedLoading((prev) => ({
  //     ...prev,
  //     [prescriptionKey]: true,
  //   }));
  //   try {
  //     const response = await dispatch(
  //       getPrescriptionExplainedAction(
  //         prescriptionId,
  //         "Yes", // prescription_explained = true
  //         selectedDate // prescription_explained_date
  //       )
  //     );
  //     if (response && response.success) {
  //       // Mark as saved
  //       setPrescriptionExplainedSaved((prev) => ({
  //         ...prev,
  //         [prescriptionKey]: true,
  //       }));
  //       Swal.fire({
  //         title: "Success!",
  //         text: "Prescription explained status updated successfully",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     } else {
  //       throw new Error("API call failed");
  //     }
  //   } catch (error) {
  //     console.error("Error updating prescription explained:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to update prescription explained status",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   } finally {
  //     setPrescriptionExplainedLoading((prev) => ({
  //       ...prev,
  //       [prescriptionKey]: false,
  //     }));
  //   }
  // };

  // // Modified: Save Medicine Started Date with API call
  // const handleSaveMedicineStartedDate = async (prescriptionKey) => {
  //   const selectedDate = medicineStartedDates[prescriptionKey];
  //   if (!selectedDate) {
  //     Swal.fire({
  //       title: "Missing Date",
  //       text: "Please select a date",
  //       icon: "warning",
  //       confirmButtonText: "OK",
  //     });
  //     return;
  //   }
  //   if (!prescriptionId) {
  //     Swal.fire({
  //       title: "Error",
  //       text: "Prescription ID is missing",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //     return;
  //   }

  //   setMedicineStartedLoading((prev) => ({ ...prev, [prescriptionKey]: true }));
  //   try {
  //     const response = await dispatch(
  //       getMedicineStartedAction(
  //         prescriptionId,
  //         "Yes", // medicine_started = true
  //         selectedDate // medicine_started_date
  //       )
  //     );
  //     if (response && response.success) {
  //       // Mark as saved
  //       setMedicineStartedSaved((prev) => ({
  //         ...prev,
  //         [prescriptionKey]: true,
  //       }));
  //       Swal.fire({
  //         title: "Success!",
  //         text: "Medicine started status updated successfully",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       });
  //     } else {
  //       throw new Error("API call failed");
  //     }
  //   } catch (error) {
  //     console.error("Error updating medicine started:", error);
  //     Swal.fire({
  //       title: "Error",
  //       text: "Failed to update medicine started status",
  //       icon: "error",
  //       confirmButtonText: "OK",
  //     });
  //   } finally {
  //     setMedicineStartedLoading((prev) => ({
  //       ...prev,
  //       [prescriptionKey]: false,
  //     }));
  //   }
  // };
  // Save Prescription Explained Date
  const handleSavePrescriptionExplainedDate = async (prescriptionKey) => {
    const selectedDate = prescriptionExplainedDates[prescriptionKey];
    if (!selectedDate) {
      return Swal.fire({
        title: "Missing Date",
        text: "Please select a date",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }

    if (!prescriptionId) {
      return Swal.fire({
        title: "Error",
        text: "Prescription ID is missing",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    setPrescriptionExplainedLoading((prev) => ({
      ...prev,
      [prescriptionKey]: true,
    }));

    try {
      const response = await dispatch(
        getPrescriptionExplainedAction(
          prescriptionId,
          "Yes", // prescription_explained = true
          selectedDate // prescription_explained_date
        )
      );

      if (response && response.success) {
        // Mark as saved
        setPrescriptionExplainedSaved((prev) => ({
          ...prev,
          [prescriptionKey]: true,
        }));

        // ✅ Update main state so button re-enables instantly
        setPrescriptionExplained((prev) => ({
          ...prev,
          [prescriptionKey]: "Yes",
        }));

        // ✅ centralized success
        handleSuccess("Prescription explained status updated successfully");
      } else {
        throw new Error("API call failed");
      }
    } catch (error) {
      console.error("Error updating prescription explained:", error);
      showErrorAlert("Failed to update prescription explained status");
    } finally {
      setPrescriptionExplainedLoading((prev) => ({
        ...prev,
        [prescriptionKey]: false,
      }));
    }
  };

  // Save Medicine Started Date
  const handleSaveMedicineStartedDate = async (prescriptionKey) => {
    const selectedDate = medicineStartedDates[prescriptionKey];
    if (!selectedDate) {
      return Swal.fire({
        title: "Missing Date",
        text: "Please select a date",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }

    if (!prescriptionId) {
      return Swal.fire({
        title: "Error",
        text: "Prescription ID is missing",
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    setMedicineStartedLoading((prev) => ({
      ...prev,
      [prescriptionKey]: true,
    }));

    try {
      const response = await dispatch(
        getMedicineStartedAction(
          prescriptionId,
          "Yes", // medicine_started = true
          selectedDate // medicine_started_date
        )
      );

      if (response && response.success) {
        // Mark as saved
        setMedicineStartedSaved((prev) => ({
          ...prev,
          [prescriptionKey]: true,
        }));

        // ✅ Update main state so button re-enables instantly
        setMedicineStarted((prev) => ({
          ...prev,
          [prescriptionKey]: "Yes",
        }));

        handleSuccess("Medicine started status updated successfully");
      } else {
        throw new Error("API call failed");
      }
    } catch (error) {
      console.error("Error updating medicine started:", error);
      showErrorAlert("Failed to update medicine started status");
    } finally {
      setMedicineStartedLoading((prev) => ({
        ...prev,
        [prescriptionKey]: false,
      }));
    }
  };

  // FIXED: Save Reminder with proper prescription_id and patient_id
  const handleSaveReminder = async () => {
    if (!reminderDate || !reminderTime) {
      Swal.fire({
        title: "Missing Information",
        text: "Please select both date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const selectedDateTime = new Date(`${reminderDate}T${reminderTime}`);
    const now = new Date();
    if (selectedDateTime <= now) {
      Swal.fire({
        title: "Invalid Date/Time",
        text: "Please select a future date and time for the reminder.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    // Validate required IDs
    if (!prescriptionId) {
      Swal.fire({
        title: "Error",
        text: "Prescription ID is missing",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    if (!patientId) {
      Swal.fire({
        title: "Error",
        text: "Patient ID is missing",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setReminderLoading(true);
    try {
      const response = await dispatch(
        addReminderAction({
          patient_id: patientId, // ✅ Use actual patient_id
          prescription_id: prescriptionId, // ✅ Use actual prescription_id
          reminder_date: reminderDate,
          reminder_time: reminderTime,
        })
      );
      if (response && response.success) {
        const newReminder = {
          prescriptionName: "Prescription Reminder",
          date: reminderDate,
          time: reminderTime,
          status: "Scheduled",
          createdAt: new Date().toISOString(),
        };
        setFollowupList((prev) => [...prev, newReminder]);
        dispatch(getFollowUpReminderListAction());

        setReminderDate("");
        setReminderTime("");
        setShowReminderModal(false);
        Swal.fire({
          title: "Success!",
          text: `Follow-up reminder has been scheduled for ${new Date(
            selectedDateTime
          ).toLocaleString()}.`,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        throw new Error(response?.error || "Failed to add reminder");
      }
    } catch (error) {
      console.error("Error adding reminder:", error);
      Swal.fire({
        title: "Error",
        text: error?.message || "Failed to add reminder",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setReminderLoading(false);
    }
  };

  const targetDate = "08/04/2025";
  const appointmentsOnDate = filteredAppointments.filter(
    (appointment) => appointment.date === targetDate
  );

  // summary dates

  // Add this safety check before the return statement
  if (!selectedPrescriptionForFollowup) {
    return null;
  }

  // Modified: Save Delay with API integration
  const handleSaveDelay = async () => {
    if (!delayDays) {
      Swal.fire({
        title: "Missing Information",
        text: "Please enter delay days",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }
    if (!selectedScheduleReason?.value) {
      Swal.fire({
        title: "Missing Selection",
        text: "Please select a schedule reason before saving delay.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    setDelayLoading(true);
    try {
      const response = await dispatch(
        addFollowupDelayAction({
          schedule_id: selectedScheduleReason.value,
          delay_days: Number.parseInt(delayDays),
        })
      );
      if (response && response.success) {
        setShowDelayModal(false);
        setDelayDays("");
        Swal.fire({
          title: "Success!",
          text: `Follow-up delay of ${delayDays} days has been added successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        throw new Error(response?.error || "Failed to add delay");
      }
    } catch (error) {
      console.error("Error adding delay:", error);
      Swal.fire({
        title: "Error",
        text: error?.message || "Failed to add follow-up delay",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setDelayLoading(false);
    }
  };

  // Add this function before the return statement
  const handleViewSchedule = async () => {
    if (!prescriptionId) {
      Swal.fire({
        title: "Error",
        text: "Prescription ID is missing",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setScheduledListLoading(true);
    try {
      const response = await dispatch(getScheduledListAction(prescriptionId));
      if (response && response.success) {
        setShowScheduleModal(true);
      } else {
        throw new Error(response?.error || "Failed to fetch scheduled list");
      }
    } catch (error) {
      console.error("Error fetching scheduled list:", error);
      Swal.fire({
        title: "Error",
        text: error?.message || "Failed to fetch scheduled list",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setScheduledListLoading(false);
    }
  };
  const receiptDownloadLink = selectedPrescriptionForFollowup?.receipt_download_link;

  // Determine if the "View Schedule" button should be disabled based on initial prescription/medicine status
  // const disableViewScheduleButton =
  //   scheduledListLoading ||
  //   (selectedPrescriptionForFollowup?.prescription_explained === "No" &&
  //     selectedPrescriptionForFollowup?.medicine_started === "No");
  // compute disabled state for a given prescription key (works for prop key or per-row key)
  // FIX: Enable "View Schedule" button dynamically once both switches are Yes
  const isViewScheduleDisabled = (key) => {
    if (scheduledListLoading) return true;

    // Local state
    const presExplainedLocal = prescriptionExplained[key];
    const medStartedLocal = medicineStarted[key];

    // API state
    const presExplainedFromApi =
      selectedPrescriptionForFollowup?.prescription_explained === "Yes";
    const medStartedFromApi =
      selectedPrescriptionForFollowup?.medicine_started === "Yes";

    // ✅ If both local or API states are true or "Yes" → enable button
    const bothExplained =
      (presExplainedLocal === true || presExplainedLocal === "Yes" || presExplainedFromApi) &&
      (medStartedLocal === true || medStartedLocal === "Yes" || medStartedFromApi);

    return !bothExplained;
  };




  return (
    <div style={{ marginTop: "-2rem" }}>
      <div className="card shadow-sm border">
        <div className="card-header text-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            <i className="fas fa-chart-line me-2"></i> Patient Follow-Up
            Tracking
          </h5>
          <div className="d-flex gap-2">
            {/* PDF Download Button */}
            {receiptDownloadLink ? (
              <button
                onClick={() => handleDownloadReceipt(prescriptionId, receiptDownloadLink)}
                disabled={downloadingId === prescriptionId}
                title="Download Prescription Receipt"
                style={{
                  background: "none",
                  border: "none",
                  padding: "4px",
                  cursor: downloadingId === prescriptionId ? "not-allowed" : "pointer",
                  opacity: downloadingId === prescriptionId ? 0.6 : 1,
                }}
              >
                {downloadingId === prescriptionId ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      style={{ width: "16px", height: "16px", color: "white" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span style={{ color: "white", fontSize: "12px" }}>Downloading...</span>
                  </div>
                ) : (
                  <img
                    src={pdfIcon || "/placeholder.svg"}
                    alt="Download Receipt"
                    width={48}
                    height={48}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </button>
            ) : (
              <Link to="#" title="Receipt Not Available">
                <img
                  src={pdfIcon || "/placeholder.svg"}
                  alt="Receipt Not Available"
                  width={48}
                  height={48}
                  style={{ cursor: "not-allowed", opacity: 0.5 }}
                />
              </Link>
            )}



            <Button variant="outline-light" size="sm" onClick={onClose}>
              <i className="fas fa-times"></i>
            </Button>
            {/* <Modal show={showScheduleModal} onHide={() => setShowScheduleModal(false)} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>Follow-Up Status</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ paddingLeft: 0, paddingRight: 0, maxHeight: "70vh", overflowY: "auto" }}>
                <div
                  style={{
                    padding: "30px 0 10px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    {(scheduledListData?.data || []).map((schedule, index, array) => {
                      const getStatusColor = (status) => {
                        switch (status?.toLowerCase()) {
                          case "completed":
                            return "#0d6efd"
                          case "ongoing":
                            return "#0dcaf0"
                          case "scheduled":
                            return "#dc3545"
                          case "pending":
                            return "#ffc107"
                          default:
                            return "#6c757d"
                        }
                      }
                      const formatDate = (dateStr) => {
                        if (!dateStr) return "N/A"
                        const date = new Date(dateStr)
                        return date.toLocaleDateString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })
                      }
                      return (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            minWidth: "160px",
                            marginRight: index !== array.length - 1 ? "0px" : "0",
                            textAlign: "center",
                            zIndex: 1,
                          }}
                        >
                      
                          <div
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              backgroundColor: getStatusColor(schedule.schedule_status),
                              border: "2px solid #fff",
                              boxShadow: `0 0 0 3px ${getStatusColor(schedule.schedule_status)}`,
                              margin: "0 auto",
                              zIndex: 2,
                            }}
                          />
                        
                          {index < array.length - 1 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "9px",
                                left: "50%",
                                width: "100%",
                                height: "2px",
                                backgroundColor: getStatusColor(schedule.schedule_status),
                                zIndex: 0,
                              }}
                            ></div>
                          )}
                        
                          <div style={{ marginTop: "12px" }}>
                            <h6
                              style={{
                                fontSize: "0.95rem",
                                fontWeight: "600",
                                marginBottom: "2px",
                              }}
                            >
                              {schedule.followup_count}
                            </h6>
                            <div
                              style={{
                                fontSize: "0.8rem",
                                color: "#555",
                                marginBottom: "4px",
                              }}
                            >
                              ({schedule.followup_frequency_days} days)
                            </div>
                            <p style={{ fontSize: "0.85rem", margin: 0 }}>
                              <strong>Date:</strong> {formatDate(schedule.followup_date)}
                            </p>
                            <p style={{ fontSize: "0.85rem", margin: 0 }}>
                              <strong>Status:</strong> {schedule.schedule_status}
                            </p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="outline-danger" onClick={() => setShowScheduleModal(false)}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal> */}

            <Modal
              show={showScheduleModal}
              onHide={() => setShowScheduleModal(false)}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Follow-Up Status</Modal.Title>
              </Modal.Header>

              <Modal.Body
                style={{
                  paddingLeft: "15px",
                  paddingRight: "15px",
                  maxHeight: "70vh",
                  overflowY: "auto",
                }}
              >
                <div style={{ padding: "20px 0 10px" }}>
                  <div
                    style={{
                      display: "flex",
                      overflowX: "auto",
                      gap: "40px",
                      paddingBottom: "20px",
                      paddingTop: "10px",
                      position: "relative",
                    }}
                  >
                    {(scheduledListData?.data || []).map(
                      (schedule, index, array) => {
                        const getStatusColor = (status) => {
                          switch (status?.toLowerCase()) {
                            case "completed":
                              return "#0d6efd"; // blue
                            case "ongoing":
                              return "#0dcaf0"; // cyan
                            case "scheduled":
                              return "#dc3545"; // red
                            case "pending":
                              return "#ffc107"; // yellow
                            default:
                              return "#6c757d"; // gray
                          }
                        };

                        const formatDate = (dateStr) => {
                          if (!dateStr) return "N/A";
                          const date = new Date(dateStr);
                          return date.toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                          });
                        };

                        return (
                          <div
                            key={index}
                            style={{
                              position: "relative",
                              textAlign: "center",
                              minWidth: "150px",
                            }}
                          >
                            {/* Dot */}
                            <div
                              style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: getStatusColor(
                                  schedule.schedule_status
                                ),
                                border: "2px solid #fff",
                                boxShadow: `0 0 0 3px ${getStatusColor(
                                  schedule.schedule_status
                                )}`,
                                margin: "0 auto",
                                zIndex: 2,
                              }}
                            />

                            {/* Connector Line */}
                            {index < array.length - 1 && (
                              <div
                                style={{
                                  position: "absolute",
                                  top: "9px",
                                  left: "50%",
                                  width: "100%",
                                  height: "2px",
                                  backgroundColor: "#ccc",
                                  zIndex: 0,
                                  transform: "translateX(10px)",
                                }}
                              ></div>
                            )}

                            {/* Info Below Dot */}
                            <div style={{ marginTop: "12px" }}>
                              <h6
                                style={{
                                  fontSize: "0.95rem",
                                  fontWeight: 600,
                                  marginBottom: "4px",
                                }}
                              >
                                {schedule.followup_count}
                              </h6>
                              <div
                                style={{
                                  fontSize: "0.8rem",
                                  color: "#555",
                                  marginBottom: "4px",
                                }}
                              >
                                ({schedule.followup_frequency_days} days)
                              </div>
                              <p style={{ fontSize: "0.85rem", margin: 0 }}>
                                <strong>Date:</strong>{" "}
                                {formatDate(schedule.followup_date)}
                              </p>
                              <p style={{ fontSize: "0.85rem", margin: 0 }}>
                                <strong>Status:</strong>{" "}
                                {schedule.schedule_status}
                              </p>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  variant="outline-danger"
                  onClick={() => setShowScheduleModal(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
        {/* Prescription info section */}
        <div className="card-body border-bottom">
          <div className="row">
            <div className="col-md-4">
              <p className="fs-5 mb-0">
                <strong>Prescribed By:</strong>{" "}
                {selectedPrescriptionForFollowup?.prescribedBy ||
                  "Unknown Doctor"}
              </p>
            </div>
            <div className="col-md-4">
              <p className="fs-5 mb-0">
                <strong>Date:</strong>{" "}
                {formatDate(selectedPrescriptionForFollowup?.date) || "Unknown Date"}
              </p>
            </div>

          </div>
        </div>
        <div className="card-body">
          {/* Summary Section */}
          <Accordion className="accordion accordion" defaultActiveKey="0">
            {appointmentsOnDate.map((appointment, index) => {
              const prescriptionNotes = appointment.notes.filter(
                (note) => note.title.trim() === "Prescription"
              );
              // Skip if no prescription notes
              if (prescriptionNotes.length === 0) return null;
              return (
                <Accordion.Item key={index} eventKey={`${index}`}>
                  <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        <strong>Prescription </strong>
                      </div>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    {prescriptionNotes.map((note, noteIndex) => (
                      <div key={noteIndex} className="mb-3">
                        <div className="p-3 rounded bg-light-primary border shadow-sm">
                          {typeof note.content === "string" ? (
                            <p className="mb-0 text-dark">{note.content}</p>
                          ) : (
                            note.content
                          )}
                        </div>
                      </div>
                    ))}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
          {/* Summary API data */}
          <div className="mb-4 border rounded p-3 shadow-sm bg-white mt-4">
            <h5 className="fw-bold mb-3">Summary</h5>
            <div className="row mb-3">
              {[
                {
                  label: "Consulting Date",
                  value: formatDate(prescriptionSummaryData.ConsultingDate),
                },
                {
                  label: "Consulting Payment Date",
                  value: formatDate(
                    prescriptionSummaryData.ConsultingPaymentDate
                  ),
                },
                {
                  label: "Convert Payment Date",
                  value: formatDate(prescriptionSummaryData.ConvertPaymentDate),
                },
                {
                  label: "Medicine Design Date",
                  value: formatDate(prescriptionSummaryData.MedicineDesignDate),
                },
                {
                  label: "Medicine Prepared Date",
                  value: formatDate(
                    prescriptionSummaryData.MedicinePreparedDate
                  ),
                },
                {
                  label: "Medicine Delivered Date",
                  value: formatDate(
                    prescriptionSummaryData.MedicineDeliveredDate
                  ),
                },
              ].map((item, idx) => (
                <div className="col-md-4 mb-2" key={idx}>
                  <strong>{item.label}:</strong> {item.value}
                </div>
              ))}
            </div>
          </div>
          {/* Prescription Tracking */}
          {appointmentsOnDate.map((appointment, index) =>
            appointment.notes.map((note, noteIndex) => {
              if (note.title.trim() === "Prescription") {
                const prescriptionKey = `${index}-${noteIndex}`;
                // Issue 1: Determine current state for display
                const currentPrescriptionExplainedState =
                  prescriptionExplained[prescriptionKey] !== undefined
                    ? prescriptionExplained[prescriptionKey]
                    : selectedPrescriptionForFollowup?.prescription_explained ===
                    "Yes";
                const displayPrescriptionExplainedDate =
                  prescriptionExplainedDates[prescriptionKey] ||
                  selectedPrescriptionForFollowup?.prescription_explained_date;

                const currentMedicineStartedState =
                  medicineStarted[prescriptionKey] !== undefined
                    ? medicineStarted[prescriptionKey]
                    : selectedPrescriptionForFollowup?.medicine_started ===
                    "Yes";
                const displayMedicineStartedDate =
                  medicineStartedDates[prescriptionKey] ||
                  selectedPrescriptionForFollowup?.medicine_started_date;

                return (
                  <div
                    key={`prescription-${prescriptionKey}`}
                    className="mb-4 border rounded p-3 shadow-sm bg-white"
                  >
                    {/* Outside: Is Prescription Explained? */}
                    {/* --- Row: Switch + View Schedule Button --- */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap mb-3">
                      {/* Your existing switch (unchanged) */}
                      <div className="form-check form-switch mb-0">
                        <label
                          className="form-check-label me-2"
                          htmlFor={`prescriptionExplained-${prescriptionKey}`}
                        >
                          Is Prescription Explained?
                        </label>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`prescriptionExplained-${prescriptionKey}`}
                          checked={currentPrescriptionExplainedState}
                          onChange={(e) =>
                            handlePrescriptionExplainedChange(
                              prescriptionKey,
                              e.target.checked
                            )
                          }
                          disabled={
                            selectedPrescriptionForFollowup?.prescription_explained === "Yes"
                          }
                        />
                        {/* Yes/No display */}
                        <span className="ms-2 text-muted">
                          {currentPrescriptionExplainedState ? "Yes" : "No"}
                          {currentPrescriptionExplainedState &&
                            displayPrescriptionExplainedDate &&
                            ` Explained on ${formatDate(displayPrescriptionExplainedDate)}`}
                        </span>

                        {prescriptionExplainedLoading[prescriptionKey] && (
                          <span className="ms-2 text-primary">
                            <i className="fas fa-spinner fa-spin"></i> Updating...
                          </span>
                        )}

                        {prescriptionExplainedSaved[prescriptionKey] && (
                          <span className="ms-2 text-success"></span>
                        )}
                      </div>


                      <div className="d-flex align-items-center gap-2 ms-auto mt-2 mt-sm-0">

                        <Button
                          variant="outline-light"
                          size="sm"
                          onClick={handleViewSchedule}
                          disabled={isViewScheduleDisabled(prescriptionKey)}
                        >
                          {scheduledListLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i> Loading...
                            </>
                          ) : (
                            "View Schedule"
                          )}
                        </Button>

                        {/* ✅ NEW SEND ICON */}
                        <button
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleSendScheduled()}
                          title="Send Schedule"
                        >
                          <i className="fas fa-paper-plane"></i>
                        </button>

                      </div>
                    </div>


                    {/* --- Rest of your code (unchanged) --- */}
                    {prescriptionExplained[prescriptionKey] && (
                      <div className="mb-3" style={{ maxWidth: 500 }}>
                        <div className="form-label mb-1">Prescription Explained Date</div>
                        <div className="d-flex align-items-center gap-2">
                          <div className="position-relative flex-grow-1">
                            <input
                              type="date"
                              className="form-control"
                              id={`medicineExplainedDate-${prescriptionKey}`}
                              value={prescriptionExplainedDates[prescriptionKey] || ""}
                              onChange={(e) =>
                                setPrescriptionExplainedDates((prev) => ({
                                  ...prev,
                                  [prescriptionKey]: e.target.value,
                                }))
                              }
                              required
                            />
                            <i
                              className="fa fa-calendar position-absolute"
                              style={{
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                fontSize: "18px",
                                color: "#888",
                              }}
                            ></i>
                          </div>
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              handleSavePrescriptionExplainedDate(prescriptionKey)
                            }
                            disabled={prescriptionExplainedLoading[prescriptionKey]}
                          >
                            {prescriptionExplainedLoading[prescriptionKey] ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-1"></i> Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </div>
                    )}


                    {/* Outside: Is Medicine Started? */}
                    <div className="form-check form-switch mb-3">
                      <label
                        className="form-check-label me-2"
                        htmlFor={`medicineStarted-${prescriptionKey}`}
                      >
                        Is Medicine Started?
                      </label>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`medicineStarted-${prescriptionKey}`}
                        checked={currentMedicineStartedState}
                        onChange={(e) =>
                          handleMedicineStartedChange(
                            prescriptionKey,
                            e.target.checked
                          )
                        }
                        disabled={
                          selectedPrescriptionForFollowup?.medicine_started ===
                          "Yes"
                        }
                      />
                      {/* Issue 1: Display "Yes" or "No" based on current switch state */}
                      <span className="ms-2 text-muted">
                        {currentMedicineStartedState ? "Yes" : "No"}
                        {currentMedicineStartedState &&
                          displayMedicineStartedDate &&
                          ` started on ${formatDate(
                            displayMedicineStartedDate
                          )}`}
                      </span>
                      {medicineStartedLoading[prescriptionKey] && (
                        <span className="ms-2 text-primary">
                          <i className="fas fa-spinner fa-spin"></i> Updating...
                        </span>
                      )}
                      {/* Show saved status */}
                      {medicineStartedSaved[prescriptionKey] && (
                        <span className="ms-2 text-success"></span>
                      )}
                    </div>
                    {/* Outside: Medicine Start Date */}
                    {medicineStarted[prescriptionKey] && (
                      <div className="mb-3" style={{ maxWidth: 500 }}>
                        <label
                          htmlFor={`medicineStartDate-${prescriptionKey}`}
                          className="form-label mb-1"
                        >
                          Medicine Start Date
                        </label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="position-relative w-100">
                            <input
                              type="date"
                              className="form-control"
                              id={`medicineStartDate-${prescriptionKey}`}
                              value={
                                medicineStartedDates[prescriptionKey] || ""
                              }
                              onChange={(e) =>
                                setMedicineStartedDates((prev) => ({
                                  ...prev,
                                  [prescriptionKey]: e.target.value,
                                }))
                              }
                              required
                            />
                            <i
                              className="fa fa-calendar position-absolute"
                              style={{
                                right: "15px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                pointerEvents: "none",
                                fontSize: "18px",
                                color: "#888",
                              }}
                            ></i>
                          </div>
                          <button
                            className="btn btn-primary"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={() =>
                              handleSaveMedicineStartedDate(prescriptionKey)
                            }
                            disabled={medicineStartedLoading[prescriptionKey]}
                          >
                            {medicineStartedLoading[prescriptionKey] ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-1"></i>{" "}
                                Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                    {/* Outside: Bottom Buttons */}
                    <div className="d-flex gap-2 mt-3">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => setShowFollowUpForm(true)}
                        disabled={showFollowUpForm}
                      >
                        Add Follow-Up
                      </button>
                      <button
                        className="btn btn-outline-info"
                        onClick={() => setShowReminderModal(true)}
                      >
                        Add Follow-Up Reminder
                      </button>
                      <button
                        className="btn btn-outline-info"
                        onClick={() => setShowDelayModal(true)}
                      >
                        Add Follow-Up Delay
                      </button>
                    </div>
                    {/* Delay Modal */}
                    <Modal
                      show={showDelayModal}
                      onHide={() => {
                        setShowDelayModal(false);
                        setDelayDays("");
                      }}
                      backdrop="static"
                      keyboard={false}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Set Follow-Up Delay</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="mb-3">
                          <label htmlFor="delayDays" className="form-label">
                            Delay (in days)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter the delay days"
                            id="delayDays"
                            name="delayDays"
                            value={delayDays}
                            min={0}
                            onChange={(e) => setDelayDays(e.target.value)}
                            required
                            autoComplete="off"
                            style={{
                              WebkitAppearance: "none",
                              MozAppearance: "textfield",
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            Schedule Follow-Up
                          </label>
                          <Select
                            value={selectedScheduleReason}
                            onChange={setSelectedScheduleReason}
                            options={followupOptions}
                            isClearable
                            placeholder="Select Schedule Follow-Up"
                            className="react-select-container"
                            classNamePrefix="react-select"
                            components={{
                              Option: CustomOption,
                              SingleValue: CustomSingleValue,
                            }}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                minHeight: "50px",
                                height: "50px",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                lineHeight: "50px",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "4px",
                              }),
                              indicatorSeparator: (provided) => ({
                                ...provided,
                                display: "none",
                              }),
                            }}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="outline-danger"
                          onClick={() => {
                            setShowDelayModal(false);
                            setDelayDays("");
                          }}
                          disabled={delayLoading}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="primary"
                          onClick={handleSaveDelay}
                          disabled={delayLoading}
                        >
                          {delayLoading ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-1"></i>{" "}
                              Saving...
                            </>
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </Modal.Footer>
                    </Modal>
                    {/* Reminder Modal */}
                    {showReminderModal && (
                      <Modal
                        show={showReminderModal}
                        onHide={() => {
                          setShowReminderModal(false);
                          setReminderDate("");
                          setReminderTime("");
                        }}
                        backdrop="static"
                        keyboard={false}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Add Follow-Up Reminder</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <div className="mb-3">
                            <label
                              htmlFor="reminderDate"
                              className="form-label"
                            >
                              Reminder Date
                            </label>
                            <div className="position-relative">
                              <input
                                type="date"
                                className="form-control"
                                id="reminderDate"
                                name="reminderDate"
                                value={reminderDate}
                                min={new Date().toISOString().split("T")[0]}
                                onChange={(e) => {
                                  console.log("Date changed:", e.target.value);
                                  setReminderDate(e.target.value);
                                }}
                                required
                                autoComplete="off"
                                style={{
                                  paddingRight: "40px",
                                  WebkitAppearance: "none",
                                  MozAppearance: "textfield",
                                }}
                              />
                              <i
                                className="fa fa-calendar position-absolute"
                                style={{
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                  fontSize: "18px",
                                  color: "#888",
                                  zIndex: 2,
                                }}
                              ></i>
                            </div>
                          </div>
                          <div className="mb-3">
                            <label
                              htmlFor="reminderTime"
                              className="form-label"
                            >
                              Reminder Time
                            </label>
                            <div className="position-relative">
                              <input
                                type="time"
                                className="form-control"
                                id="reminderTime"
                                name="reminderTime"
                                value={reminderTime}
                                onChange={(e) => {
                                  console.log("Time changed:", e.target.value);
                                  setReminderTime(e.target.value);
                                }}
                                required
                                autoComplete="off"
                                style={{
                                  paddingRight: "40px",
                                  WebkitAppearance: "none",
                                  MozAppearance: "textfield",
                                }}
                              />
                              <i
                                className="fa fa-clock position-absolute"
                                style={{
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  pointerEvents: "none",
                                  fontSize: "18px",
                                  color: "#888",
                                  zIndex: 2,
                                }}
                              ></i>
                            </div>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            type="button"
                            className="btn btn-outline-danger"
                            onClick={() => {
                              setShowReminderModal(false);
                              setReminderDate("");
                              setReminderTime("");
                            }}
                            disabled={reminderLoading}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveReminder}
                            disabled={reminderLoading}
                          >
                            {reminderLoading ? (
                              <>
                                <i className="fas fa-spinner fa-spin me-1"></i>{" "}
                                Saving...
                              </>
                            ) : (
                              "Save"
                            )}
                          </button>
                        </Modal.Footer>
                      </Modal>
                    )}
                  </div>
                );
              }
              return null;
            })
          )}
          {/* Follow-up Form */}
          <FollowUpForm
            showFollowUpForm={showFollowUpForm}
            setShowFollowUpForm={setShowFollowUpForm}
            followupOptions={followupOptions}
            CustomOption={CustomOption}
            CustomSingleValue={CustomSingleValue}
            prescriptionId={prescriptionId}
            patientId={patientId}
          />
          {/* Questionnaire Section */}
          <QuestionnaireSection prescriptionId={prescriptionId} />
        </div>
      </div>
    </div>
  );
};

PrescriptionFollowUp.propTypes = {
  selectedPrescriptionForFollowup: PropTypes.object.isRequired,
  prescriptionKey: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  patientName: PropTypes.string,
  patientGender: PropTypes.string,
};

export default PrescriptionFollowUp;
